import Parser from 'web-tree-sitter';

const WASM_BASE = '/static/default/js/convert/curlconverter/';

await Parser.init({
    locateFile(scriptName) {
        return WASM_BASE + scriptName;
    },
});

const Bash = await Parser.Language.load(WASM_BASE + 'tree-sitter-bash.wasm');
const parser = new Parser();
parser.setLanguage(Bash);

export default parser;
